import {RxJsUtils}  from 'src/app/@core/utils/rxjs.utils'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppLoaderService } from './../../@shared/services/app-loader.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private readonly appLoaderService: AppLoaderService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler,): Observable<HttpEvent<unknown>> {
    request = request.clone({

      // request.url.includes('https://graph.microsoft.com/v1.0/me') || request.url.includes(environment.apiEndPoint)
      url: request.url.includes('https://graph.microsoft.com/v1.0/me') || request.url.includes(environment.apiEndPoint) ? `${request.url}` : `${environment.apiEndPoint}/${request.url}`,
    });
    this.appLoaderService.toggleLoader(true);

    const { urlWithParams } = request;

    return next.handle(request).pipe(RxJsUtils.shareDuplicate(urlWithParams));
  }
}


// export checkApiEndPoint(){

// }
